import { styled } from 'theme'

export const StyledRealEstateSettingsNav = styled.div`
  background-color: white;
`
